import { atom } from "recoil";

export const factorAtom = atom({
  key: "factorData",
  default: {},
});

export const idPersonAtom = atom({
  key: "idPerson",
  default: "",
});
